// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  sistemaWebAdmin: "https://solucionesiot.svaclaroperu.com/api/api", //    "https://localhost:7058/api",//     "https://app-plataforma-industria-back-end.azurewebsites.net/api",// "http://localhost:5051/api", //"https://app-plataforma-industria-back-end.azurewebsites.net/api",  // // //"http://localhost:34109/api", //  "https://gys-plataforma-back.azurewebsites.net/api",// "http://localhost:5051/api", //
  identityServer: "http://localhost:16774/connect/token",
  showroomUrl: "http://localhost:5000/api/showroom",//"http://192.168.2.51:5001/api/showroom",// //
  clientId: 'userapp',
  clientSecret: 'd60d6b88-bf36-463f-ae90-b423188bf1bf',
  grantType: 'userapp_validator',
  azAdClientId: '84b95b61-c3c9-470d-aa86-f20a6fcdbac3',
  azAdTenantId: '932d69f5-a800-4527-9dcf-eabfe5c25af4',
  azScopeId : '32550834-19c0-4a14-bf40-aa0d61c7f1ce',
  azScopeName : 'access_as_user',
  expiredLicense: '2030-07-11',
  themeColor1: '#1d1d2b',//'#1f5165', //menu, background
  themeColor2: '#1bc0db',//'#1f5165', //icon,background
  themeColorFont1: '#1d1d2b',
  themeColorFont2: '#1bc0db',
  logoPrincipal: 'assets/images/example.png',
  logoEnterprise: 'assets/images/g&s-logo.png', //'assets/images/Claro.svg',
  pathFile: '../../../../',
  camaraAlert: 'http://192.168.2.53:5001/api/showroom',
  wsUrl: 'https://app-plataforma-industria-back-end.azurewebsites.net',// "https://localhost:5001", //'http://localhost:5000',
  storage:'https://stplataformaindustria.blob.core.windows.net',//'https://storage01industria04qa.blob.core.windows.net',//'https://rgplataformai48a4e.blob.core.windows.net',//
  fnVA: "https://fn-plataforma-industria-va.azurewebsites.net", // "https://fcplataforma.azurewebsites.net",
  fnIOT: "https://fnfromiot01industria04qa.azurewebsites.net", //"https://fcplataforma.azurewebsites.net", //https://fnfromiot01industria04qa.azurewebsites.net",
  //fnNotification: "https://fnfromiot03industria04qa.azurewebsites.net",
  titleLogin: "Plataforma de industria 4.0",
  mapbox: {
    accessToken: 'pk.eyJ1Ijoic2ViYXN0aWFuOTZqcCIsImEiOiJjbGl4bjhpaGEwODB5M2xsMndvOWhxeXZqIn0.Yt4_ynMIZUiiJF4TS3exVA'
  }
};